import difference from 'lodash/difference'
import map from 'lodash/map'
import each from 'lodash/each'
import filter from 'lodash/filter'
import { IApplicationState } from '@Site/rootReducer'
import { getSelectedProjectIds } from '@SiteModules/Project/selectors'

import { createSelector } from 'reselect'

import {
  ILabel,
} from './types'

export const getLabels = (state: IApplicationState): ILabel[] => state.labels.labels
export const getSelectedLabelIds = (state: IApplicationState): number[] => state.labels.selectedLabelIds
export const getHasLoadedInitially = (state: IApplicationState): boolean => state.labels.hasLoadedInitially

export const getLabelCaptions = createSelector(
  [getLabels],
  (labels) => {
    return map(labels, label => label.attributes.caption)
  }
)

export const getLabelIds = createSelector(
  [getLabels],
  (labels) => {
    return map(labels, label => label.id)
  }
)

export const getLabelsInAllSelectedProjects = createSelector(
  [getLabels, getSelectedProjectIds],
  (labels, selectedProjectIds) => {
    const labelsInAllSelectedProjects: number[] = []

    each(labels, label => {
      if (difference(selectedProjectIds, label.attributes.projectIds).length === 0) {
        labelsInAllSelectedProjects.push(label.id)
      }
    })
    return labelsInAllSelectedProjects
  }
)

export const getLabelsInSomeButNotAllSelectedProjects = createSelector(
  [getLabels, getSelectedProjectIds],
  (labels, selectedProjectIds) => {
    const labelsInNoSelectedProject: number[] = []

    each(labels, label => {
      const diff = difference(selectedProjectIds, label.attributes.projectIds)
      if (diff.length !== selectedProjectIds.length && diff.length !== 0) {
        labelsInNoSelectedProject.push(label.id)
      }
    })
    return labelsInNoSelectedProject
  }
)

export const getSelectedLabelCaptions = createSelector(
  [getLabels, getSelectedLabelIds], (labels, selectedLabelIds) => {
    return (
      map(filter(labels, label => selectedLabelIds.includes(label.id)), label => label.attributes.caption)
    )
  }
)
